import { upperFirst } from 'lodash'

import { getTranslation } from 'src/commons/i18n'
import { IEntry } from 'src/components/SidePanel/Components/CheckboxesSection'

import { ISection } from './types'

const { t } = getTranslation()

// remove filterType parameter when filter types naming will be standardized
export function getProviderSection(args: { entries: IEntry[]; filterType?: string; formatValue?: boolean }): ISection {
  return {
    filterType: 'provider',
    formatValue: true,
    showSelectAll: true,
    title: upperFirst(t('filtersPanel.provider')),
    ...args,
  }
}

export function getVehicleTypeSection(args: { disabled?: boolean; entries: IEntry[]; filterType?: string }): ISection {
  return {
    filterType: 'category',
    formatValue: true,
    showSelectAll: true,
    title: upperFirst(t('filtersPanel.vehicleType')),
    ...args,
  }
}

export function getPropulsionTypeSection(args: {
  disabled?: boolean
  entries: IEntry[]
  filterType?: string
}): ISection {
  return {
    filterType: 'propulsion',
    formatValue: true,
    showSelectAll: true,
    title: upperFirst(t('filtersPanel.propulsionType')),
    ...args,
  }
}

export function getLocationTypeSection(args: { disabled?: boolean; entries: IEntry[]; filterType?: string }): ISection {
  return {
    filterType: 'locationType',
    formatValue: true,
    showSelectAll: true,
    title: upperFirst(t('filtersPanel.locationType')),
    ...args,
  }
}

export function getStatusSection(args: { entries: IEntry[] }): ISection {
  return {
    filterType: 'status',
    formatValue: true,
    showSelectAll: true,
    title: upperFirst(t('filtersPanel.status')),
    ...args,
  }
}

export function getOffenseStatusSection(args: { entries: IEntry[] }): ISection {
  return {
    filterType: 'offenseStatus',
    formatValue: true,
    showSelectAll: true,
    title: upperFirst(t('filtersPanel.offense.status')),
    ...args,
  }
}

export function getEventTypesSection(args: { entries: IEntry[] }): ISection {
  return {
    filterType: 'eventTypes',
    formatValue: true,
    showSelectAll: true,
    title: upperFirst(t('filtersPanel.event_types')),
    ...args,
  }
}

export function getCloseMeansOfTransportSection(args: {
  disabled?: boolean
  entries: IEntry[]
  filterType?: string
}): ISection {
  return {
    filterType: 'closeMeansOfTransport',
    formatValue: true,
    showSelectAll: true,
    title: upperFirst(t('filtersPanel.close_means_of_transport')),
    ...args,
  }
}
